import { CompatibleProductTypeValues, HostingDisplayName } from '@atlassian/mpac-types';
import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
export const formatVersionRange = ({
  minimumVersion,
  maximumVersion
}) => {
  if (!(minimumVersion && maximumVersion)) return '';

  if (minimumVersion === maximumVersion) {
    return minimumVersion;
  }

  return "".concat(minimumVersion, " - ").concat(maximumVersion);
}; // TODO: extract out commonality b/w this and `getCompatibleVersionsSummary` in `/VersionsTab/utils/compatibleVersionsSummary.js`

export const getProductCompatibilityList = compatibilities => compatibilities.map(compatibility => {
  const {
    name
  } = compatibility;

  if (compatibility.__typename === CompatibleProductTypeValues.CLOUD_PRODUCT) {
    return [name, HostingDisplayName[AtlassianProductHostingTypeValues.Cloud]].join(' ');
  }

  if (compatibility.__typename === CompatibleProductTypeValues.SERVER_PRODUCT) {
    const {
      minimumVersion,
      maximumVersion
    } = compatibility;
    return [name, HostingDisplayName[AtlassianProductHostingTypeValues.Server], formatVersionRange({
      minimumVersion,
      maximumVersion
    })].join(' ');
  }

  if (compatibility.__typename === CompatibleProductTypeValues.DATACENTER_PRODUCT) {
    const {
      minimumVersion,
      maximumVersion
    } = compatibility;
    return [name, HostingDisplayName[AtlassianProductHostingTypeValues.DataCenter], formatVersionRange({
      minimumVersion,
      maximumVersion
    })].join(' ');
  }

  return null;
}).filter(Boolean);
export const getProductCompatibilitySummary = compatibilities => getProductCompatibilityList(compatibilities).join(', ').trim();
export const compatibleWithCloudSupportedProduct = compatibleProducts => compatibleProducts.some(product => {
  var _product$atlassianPro;

  return (_product$atlassianPro = product.atlassianProduct) === null || _product$atlassianPro === void 0 ? void 0 : _product$atlassianPro.hostingOptions.some(option => option === AtlassianProductHostingTypeValues.Cloud);
});